import { useController, useFormState } from "react-hook-form";

import { InputOTPControlledProps } from "./types";
import { InputOTP } from "@repo/core/components/core/InputOTP";

export const InputOTPControlled = ({
  name,
  control,
  defaultValue,
  isRequired,
  ...props
}: InputOTPControlledProps) => {
  const { field, fieldState } = useController({
    control,
    name,
    defaultValue
  });

  const { isSubmitted } = useFormState({
    control,
    name
  });

  const showError = !!fieldState.error && (fieldState.isTouched || isSubmitted);

  return (
    <InputOTP
      {...props}
      isInvalid={showError}
      isRequired={isRequired}
      placeholder="0"
      errorMessage={showError ? fieldState.error?.message || "" : ""}
      onChange={field.onChange}
      value={field.value ?? ""}
      name={field.name}
    />
  );
};
